var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashMiMong = function SvgSplashMiMong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9E9B9A",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.66 14.213v1.128c0 .712-.577 1.29-1.289 1.29h-1.21v5.112l1.272 3.178a2.063 2.063 0 1 1-3.83 0l1.27-3.176V16.63h-1.209a1.29 1.29 0 0 1-1.289-1.289v-4.513a2.58 2.58 0 0 1 2.578-2.578h1.13a2.58 2.58 0 0 1 2.577 2.578v1.128m-3.142 11.647-.719 1.797a.774.774 0 1 0 1.437 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M27.56 13.193a.082.082 0 1 1 .165 0 .082.082 0 0 1-.164 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.575 26.68a5.1 5.1 0 0 0 2.06.425h1.64c3.485 0 5.967-3.386 4.917-6.71L20.067 20l-.488-2.376a3.87 3.87 0 0 0-3.73-3.089h.177a1.048 1.048 0 0 0 0-2.095h-3.143a1.048 1.048 0 0 0 0 2.095h.178a3.87 3.87 0 0 0-3.73 3.089L8.843 20l-.125.395a5.12 5.12 0 0 0 .657 4.459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.574 22.339a2.119 2.119 0 1 1-4.238 0 2.119 2.119 0 0 1 4.237 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M10.31 25.918a.082.082 0 1 1 .165 0 .082.082 0 0 1-.164 0Z"
  }))));
};
export default SvgSplashMiMong;